import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loading from './Loading';
import { login } from '../actions/authAction';

const Redirect = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const dark = useSelector((state) => state.dark.data);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const [token, setToken] = useState(query.get('token'));

  useEffect(() => {
    if (token) {
      dispatch(login(token));
    }
  }, [token]);

  useEffect(() => {
    if (isAuthenticated) {
      console.log(133);
      navigate('/dashboard');
    }
  }, [isAuthenticated]);

  return (
    <div
      className='w-100 h-100 dashboard pb-4 overflow-hidden'
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/images/building${
          dark ? '' : '-Light'
        }.png')`,
      }}
    >
      <div className='d-flex align-items-center h-100 justify-content-center'>
        {token ? <Loading /> : <>User Not Found</>}
      </div>
    </div>
  );
};

export default Redirect;
